import React, { useEffect } from "react";
import Login from "./screens/Login";
import './App.scss';
import axios from "axios";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Home from "./screens/Home";
import { setOverlayNotice, setSwitchGraphMonth, setSwitchGraphWeek, setSwitchGraphYear, setSwitchMonth, setSwitchViewWeek, setSwitchViewYear, setSwitchWeek, setView } from "./features/settingSlice";
import { setCurrentBalance, setCurrentBalanceEnrica, setCurrentPod, setInfo, setLoggedIn, setPodsList, setOfferta, setExpiryBalanceEnrica, setDatiPagamento, setNuoviDatiContratto, setNotifiche, setTotaleConsumi, setTotaleOneri, setUltimoSaldo, setTotaleSaldo, setIdGruppo, setPayMethodDefault } from "./features/userSlice";
import Header from './components/Header'
import { DateTime, Settings } from "luxon";
import { setDataBox } from "./features/dataBoxHomeSlice";
import { setDataMin } from "./features/dataMonthSlice";
import Profilo from "./screens/Profilo/Profilo";
import ProfiloGas from "./screens/Profilo/ProfiloGas";
import Movimenti from "./screens/Movimenti";
import Ricarica from "./screens/Ricarica";
import AddMethod from './screens/AddMethod';
import NotFound from "./screens/NotFound";
import SogliaTaglia from './screens/SogliaTaglia';
import AreaGas from "./screens/AreaGas";
import Stime from "./screens/Stime";
import DocumentiGas from "./screens/DocumentiGas";
import Voltura from './components/FaiDaTe/_Voltura';
import Spostamento from "./components/FaiDaTe/_Spostament";
import Chiudere from './components/FaiDaTe/_Chiudere';
import Aumento from './components/FaiDaTe/_Aumento';
import Diminuzione from './components/FaiDaTe/_Diminuzione';
import CambioDestinazione from './components/FaiDaTe/_CambioDestinazione';
import CambioMetodoPagamento from './components/FaiDaTe/_CambioMetodoPagamento';
import AltriOneri from './screens/AltriOneri';
import PianiDisponibili from "./screens/PianiDisponibili";
import ModificaPiano from "./screens/ModificaPiano";
import YourPlan from "./screens/YourPlan";
import PlanDetails from './components/PlanBoxs/PlanDetails';
import Ricaricabile from "./screens/Piani/Ricaricabile";
import NewPlanRecap from './components/PianiDisponibili/NewPlanRecap';
import Relax from "./screens/Piani/Relax";
import Tradizionale from "./screens/Piani/Tradizionale";
import RicaricaEffettuata from './components/RicaricaEffettuata/RicaricaEffettuata';
import ChoosePayMethod from './screens/ChoosePayMethod';
import AddPayMethod from './screens/AddPayMethod/AddPayMethod';
import md5 from "md5";
import ModificaEffettuata from './components/ModificaEffettuata/ModificaEffettuata';
import HomeGas from "./screens/HomeGas";
import RichiestaEffettuata from "./components/RichiestaEffettuata/RichiestaEffettuata";
import ChangePayMethod from "./screens/ChangePayMethod/ChangePayMethod";
import Letture from './screens/Lettura/Letture';
import LettureGas from './screens/Lettura Gas/Letture';
import FaiDaTe from './screens/Fai da te/FaiDaTe';
import Assistenza from './screens/Fai da te/_Assistenza';
import { useFetchLogin } from './functions/login'
import ChangePayMethodGas from "./screens/ChangePayMethodGas/ChangePayMethod";
import Fatture from "./screens/Fatture/Fatture";
import FattureGas from "./screens/Fatture Gas/FattureGas";

import Promo from "./screens/Promo/Promo";
import DettagliRinnovo from './screens/DettagliRinnovo/DettagliRinnovo';
import HomeNew from "./screens/Home/Home";
import MovimentiNew from "./screens/Movimenti/MovimentiNew";
import MovimentiNewGas from './screens/Movimenti Gas/MovimentiNewGas';
import Errore from "./components/Errore/Errore";
import Consumi from "./screens/Consumi/Consumi";
import NewLetture from "./screens/Lettura/NewLetture";
import NewLettureGas from "./screens/Lettura Gas/NewLetture";
import NewFaiDaTe from "./screens/Fai da te/NewFaiDaTe";
import NewConsumi from "./screens/Consumi/NewConsumi";
import StoryPage from "./screens/StoryPage/StoryPage";
import NuovoContratto from "./screens/NuovoContratto/NuovoContratto";



Settings.defaultLocale = 'it';

function App() {
  const dispatch = useDispatch();

  const userLogged = useSelector((user) => user.user.logged);
  const fetchLogin = useFetchLogin()
  const selectorUser = useSelector((user) => user.user)
  const customerId = selectorUser.info && selectorUser.info.customer_id
  
  /* window.addEventListener('popstate', (event) => {
    window.history.forward()
  }); */


  useEffect(() => {

    if (localStorage.getItem('logged')) {
      fetchLogin()
    }
  }, [dispatch]);

  const getMethod = async (props) => {
    const tkn = md5(props + 'oYmAIdtki%lu')
    const apiMethod = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getMetodiPagamento.php?customer_id=${props}&tkn_pvt=${tkn}`
    const {data} = await axios.get(apiMethod)
    dispatch(setPayMethodDefault(data.dati.metodo_predefinito))
  }
  const ScrollToTop = (props) => {
    const location = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
  
    return <>{props.children}</>
  };
 
  return (
    <>
      <div className="App">
        <Router>
          {userLogged ? (
            <>
                <Routes>
                  <Route index exact strict path="/enrica/" element={<HomeNew />} />
                  <Route exact strict path={"/enrica/il-tuo-piano"} element={<YourPlan />}/>
                  <Route exact strict path={"/enrica/dettagli-piano"} element={<PlanDetails />}/>
                  <Route exact strict path={"/enrica/piano-ricaricabile"} element={<Ricaricabile />}/>
                  <Route exact strict path={"/enrica/piano-relax"} element={<Relax />}/>
                  <Route exact strict path={"/enrica/piano-tradizionale"} element={<Tradizionale />}/>
                  <Route exact strict path={"/enrica/nuovo-piano"} element={<NewPlanRecap />}/>
                  <Route exact strict path={"/enrica/consumi"} element={<NewConsumi />}/>
                  <Route exact strict path={"/enrica/movimenti-test"} element={<Movimenti />} />
                  <Route exact strict path={"/enrica/movimenti"} element={<MovimentiNew />} />
                  <Route exact strict path={"/enrica/profilo"} element={<Profilo />} />                    
                  <Route exact strict path="/enrica/profilo/aggiungi" element={<AddPayMethod />} />                    
                  <Route exact strict path="/enrica/documenti" element={<Fatture />} />    
                  <Route exact strict path="/enrica/fatture" element={<Fatture />} />                    
                  <Route exact strict path="/enrica/altri-oneri" element={<AltriOneri />} />                    
                  <Route exact strict path="/enrica/ricarica" element={<Ricarica />} />     
                  <Route exact strict path="/enrica/fai-da-te" element={<NewFaiDaTe />}/>  
                  <Route exact strict path="/enrica/fai-da-te/faq" element={<Assistenza />}/>                 
                  <Route exact strict path="/enrica/fai-da-te/stime" element={<Stime />}/>                    
                  <Route exact strict path="/enrica/fai-da-te/soglia-taglia" element={<SogliaTaglia />}/>                                    
                  <Route exact strict path="/enrica/fai-da-te/voltura" element={<Voltura />}/>                  
                  <Route exact strict path="/enrica/fai-da-te/spostamento" element={<Spostamento />}/>                  
                  <Route exact strict path="/enrica/fai-da-te/chiudere" element={<Chiudere />}/>
                  <Route exact strict path="/enrica/fai-da-te/aumento-potenza" element={<Aumento />}/>
                  <Route exact strict path="/enrica/fai-da-te/diminuzione-potenza" element={<Diminuzione />}/>
                  <Route exact strict path="/enrica/fai-da-te/cambio" element={<CambioDestinazione />}/>
                  <Route exact strict path="/enrica/scegli-piano" element={<PianiDisponibili />}/>
                  <Route exact strict path="/enrica/modifica-piano" element={<ModificaPiano />}/>
                  <Route exact strict path="/enrica/story-promo" element={<StoryPage />} /> 
                  <Route exact strict path="/enrica/gas" element={<HomeGas />}/>
                  <Route exact strict path="/enrica/gas/consumi" element={<AreaGas />}/>
                  <Route exact strict path='/enrica/gas/rinnovo-contrattuale' element={<NuovoContratto />} />
                  {/* <Route exact strict path="/enrica/gas/documenti" element={<FattureGas />}/> */}
                  <Route exact strict path="/enrica/gas/fatture" element={<FattureGas />}/>
                  <Route exact strict path="/enrica/gas/movimenti" element={<MovimentiNewGas /> }/>
                  <Route exact strict path="/enrica/gas/profilo" element={<ProfiloGas />}/>
                  <Route exact strict path="/enrica/ricarica-confermata" element={<RicaricaEffettuata />}/>
                  <Route exact strict path="/enrica/richiesta-inoltrata" element={<RichiestaEffettuata />}/>
                  <Route exact strict path="/enrica/errore" element={<Errore />}/>

                  <Route exact strict path="/enrica/cambio-metodo" element={<ChangePayMethod />}/>
                  <Route exact strict path="/enrica/gas/cambio-metodo" element={<ChangePayMethodGas />}/>
                  <Route exact strict path="/enrica/scegli-metodo-di-pagamento" element={<ChoosePayMethod />}/>
                  <Route exact strict path="/enrica/letture" element={<NewLetture/>} />
                  <Route exact strict path="/enrica/gas/letture" element={<NewLettureGas/>} />
                  <Route exact strict path="/enrica/promo" element={<Promo />}/>
                  <Route exact strict path="/enrica/dettagli-rinnovo" element={<DettagliRinnovo />}/>

                  <Route exact strict path="*" element={<NotFound />} />               
                </Routes>
           
            </>
          ) : (
            <Routes>
              <Route path={"/enrica/"} element={<Login />} />
            </Routes>
          )}
        </Router>

      </div>
      <div className='text-media-container'>
        {/* <iframe id="forceMobile" className="force-mobile" src="https://my.revoluce.it/enrica"></iframe> */}
            <h1 style={{color: 'white'}}>Ti consigliamo di visualizzare da smartphone</h1>
      </div>
    </>
  );


}

export default App;

